<template>
    <div>
        <div v-if="loanProductsLoading"
            style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;">
            <div>
                <div>
                    <h3>Getting Loans ready...</h3>
                </div>
            </div>
        </div>
        <modal v-show="createLoanModal" @close="createLoanModal = false" footer modalIsLarge>
            <template v-slot:title>
                <h5>Create Loan Application</h5>
            </template>
            <template v-slot:body>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">Account Number</label>
                            <input type="text" class="form-control" name="title"
                             v-model="loan_data.account_number" 
                                @keyup="checkAccountNumber"
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">&nbsp;</label>
                            <button @click.prevent="getAccountDetails" :disabled="get_account_detail_loading"
                                class="btn btn-primary form-control">
                                <span class="custom-loader" v-if="get_account_detail_loading">
                                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                                    <span style="font-weight: 600; text-transform: initial;">Fetching Account
                                        Details...</span>
                                </span>
                                <span v-else>
                                    Get Account Details
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="account_details">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">Account Name</label>
                            <input type="text" class="form-control" name="title" readonly
                                v-model="account_details.name" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">BVN</label>
                            <input type="text" class="form-control" name="title" readonly
                                v-model="account_details.bvn" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="title">Address</label>
                            <input type="text" class="form-control" name="title" v-model="loan_data.address" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">City</label>
                            <input type="text" class="form-control" name="title" v-model="loan_data.city" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="state">State</label>
                            <select name="state" v-model="loan_data.state_id" class="form-control">
                                <option value selected disabled>Select state</option>
                                <option :value="state.id" v-for="state in states" :key="state.id">{{ state.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">Nature of Business</label>
                            <select name="nature_of_business" v-model="loan_data.nature_of_business"
                                class="form-control">
                                <option value selected disabled>Select Nature of Business</option>
                                <option value="employed">Employed</option>
                                <option value="self-employed">Self Employed</option>
                                <option value="others">Others</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">Business Description</label>
                            <textarea name="business_description" v-model="loan_data.business_description"
                                class="form-control"></textarea>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">Duration(Months)</label>
                            <input type="number" class="form-control" name="title" v-model="loan_data.duration" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">Payment Frequency</label>
                            <select name="payment_frequency" v-model="loan_data.payment_frequency" class="form-control">
                                <option value selected disabled>Select Payment Frequency</option>
                                <option value="daily">Daily</option>
                                <option value="weekly">Weekly</option>
                                <option value="monthly">Monthly</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="title">Amount</label>
                            <input type="number" class="form-control" name="title" v-model="loan_data.amount_requested" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="title">Referral code</label>
                            <input type="text" class="form-control" name="title" v-model="loan_data.referral_code" />
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <button class="btn btn-success text-white" @click.prevent="createApplication"
                    :disabled="create_application_loading">
                    <span class="custom-loader" v-if="create_application_loading">
                        <loader-icon size="1.5x" class="custom-class"></loader-icon>
                        <span style="font-weight: 600; text-transform: initial;">Creating Application...</span>
                    </span>
                    <span v-else>
                        Start Application
                    </span>
                </button>
                <button @click.prevent="closeCreateModal" class="btn btn-secondary">
                    Cancel
                </button>
            </template>
        </modal>
        <modal v-show="createLoanCbaModal" @close="createLoanCbaModal = false" footer modalIsLarge>
            <template v-slot:title>
                <h5>Create Loan Application From CBA</h5>
            </template>
            <template v-slot:body>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">CBA Loan Account Number</label>
                            <input type="text" class="form-control" name="title"
                             v-model="cba_reference" 
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="title">&nbsp;</label>
                            <button @click.prevent="getCbaAccountDetails" :disabled="get_cba_account_detail_loading"
                                class="btn btn-primary form-control">
                                <span class="custom-loader" v-if="get_cba_account_detail_loading">
                                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                                    <span style="font-weight: 600; text-transform: initial;">Fetching Account
                                        Details...</span>
                                </span>
                                <span v-else>
                                    Get Loan Account Details
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="cba_loan_details">
                    <div class="col-md-6">
                        <KeyValue
                            objKey="Account Name"
                            :objValue="cba_loan_details.account_name"
                        />
                    </div>
                    <div class="col-md-6">
                        <KeyValue
                            objKey="Account Number"
                            :objValue="cba_loan_details.account_number"
                        />
                    </div>
                    <div class="col-md-12">
                        <KeyValue
                            objKey="Adress"
                            :objValue="cba_loan_details.address"
                        />
                    </div>
                    <div class="col-md-6">
                        <KeyValue
                            objKey="Amount Requested"
                            :objValue="cba_loan_details.amount_requested"
                        />
                    </div>
                    <div class="col-md-6">
                        <KeyValue
                            objKey="CBA Account"
                            :objValue="cba_loan_details.core_banking_loan_reference"
                        />
                    </div>
                    <div class="col-md-6">
                        <KeyValue
                            objKey="Interest Amount"
                            :objValue="cba_loan_details.interest_amount"
                        />
                    </div>
                    <div class="col-md-6">
                        <KeyValue
                            objKey="Interest Rate"
                            :objValue="cba_loan_details.interest_rate"
                        />
                    </div>
                    <div class="col-md-6">
                        <KeyValue
                            objKey="Loan Balance"
                            :objValue="cba_loan_details.loan_balance"
                        />
                    </div>
                    <div class="col-md-6">
                        <KeyValue
                            objKey="Loan Status"
                            :objValue="cba_loan_details.loan_status"
                        />
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <button class="btn btn-success text-white" @click.prevent="getCbaAccountDetails"
                    :disabled="get_cba_account_detail_loading" v-if="cba_loan_details">
                    <span class="custom-loader" v-if="get_cba_account_detail_loading">
                        <loader-icon size="1.5x" class="custom-class"></loader-icon>
                        <span style="font-weight: 600; text-transform: initial;">Creating Application...</span>
                    </span>
                    <span v-else>
                        Start Application
                    </span>
                </button>
                <button @click.prevent="closeCbaCreateModal" class="btn btn-secondary">
                    Cancel
                </button>
            </template>
        </modal>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h1 class="mb-2 font-regular">Other Loans</h1>
        </div>
        <div>
            <div class="col-md-12">
                <div class="card card--no-shadow card-profile">
                    <div class="card-header">
                        <div class=" row justify-content-between">
                            <div class="col-auto">
                                <slot name="header">
                                    <h3 class="font-weight-600 mb-0 align-left">Filter Loan Report</h3>
                                </slot>
                            </div>
                            <div class="col-auto" v-if="permissions.includes('create-other-loan')">
                                <button class="btn btn-primary" @click="showCreateLoanModal">Create Loan
                                    Application</button>
                                <button class="btn btn-primary" @click="showCbaCreateLoanModal">Create CBA Loan
                                    Application</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="loan_status">Status</label>
                                        <select name="loan_status" v-model="status" class="form-control">
                                            <option value="" selected>Please Select Loan Status</option>
                                            <option value="pending">
                                                Pending
                                            </option>
                                            <option value="in-review">
                                                In Review
                                            </option>
                                            <option value="awaiting-disbursement">
                                                Awaiting
                                            </option>
                                            <option value="active">
                                                In Loan
                                            </option>
                                            <option value="disbursed">
                                                Disbursed
                                            </option>                                            
                                            <option value="admin-loans">
                                                Admin Loans
                                            </option>                                            
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Accoount Number</label>
                                        <input type="text" @keypress="isNumber($event)" class="form-control"
                                            v-model="account_number" placeholder="08012345678" maxlength="13" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Reference</label>
                                        <input type="text" class="form-control" placeholder="83IJDK2DHEU"
                                            v-model="ref" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button @click.prevent="allProductLoan(1)" class="button w-100 mt-2"
                                        :disabled="reportsLoading">
                                        <span class="custom-loader" v-if="reportsLoading">
                                            <loader-icon size="1.5x" class="custom-class"></loader-icon>
                                            <span style="font-weight: 600; text-transform: initial;">Fetching Loan
                                                Data...</span>
                                        </span>
                                        <span v-else>
                                            Filter
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <other-loan-table v-if="!loanProductsLoading" :loanProducts="loanProducts"
                @onPageChangeAction="onPageChange" :current="current" :total="total" />
        </div>
    </div>
</template>

<script>
import VueDataTable from "@/components/VueDataTable";
// import { mapGetters } from "vuex";
import CCard from "@/components/CCard";
import KeyValue from "../../components/KeyValue.vue";
import CModal from "@/components/CModal";
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "@/services/api.service";
import Swal from "sweetalert2";
// import ErrorService from "@/services/error.service";
import CPagination from "../../components/CPagination.vue";
import ErrorService from "@/services/error.service";
// import { ClipboardIcon, CreditCardIcon } from "vue-feather-icons";
// let currentTab = 0;


export default {
    components: {
        VueDataTable,
        KeyValue,
        // ClipboardIcon,
        CCard,
        CModal,
        CDataTable,
        CPagination
        // CreditCardIcon
    },
    computed: {
        permissions() {
            let permissions = this.$store.getters.permissions;
            return permissions;
        },
        // ...mapGetters(["reportsLoading"]),
        removeCommaFromAmount() {
            return this.loan_amount.toString().replace(/,/g, "");
        }
    },
    data() {
        return {
            loanProductsLoading: true,
            loanProducts: [],
            end_date: "",
            start_date: "",
            account_number: "",
            customer_id: "",
            next_page: 1,
            total: 1,
            current: 1,
            reference: "",
            bvn: "",
            phone: "",
            ref: "",
            status: "",
            reportsLoading: true,
            kpiObj: null,
            kpiLoading: false,
            createLoanModal: false,
            createLoanCbaModal: false,
            get_account_detail_loading: false,
            create_application_loading: false,
            get_cba_account_detail_loading: false,
            account_details: null,
            cba_reference: null,
            cba_loan_details: null,
            states: null,
            loan_data: {
                source: "admin",
                account_name: "",
                account_number: "",
                address: "",
                city: "",
                state_id: "",
                nature_of_business: "",
                business_description: "",
                duration: "",
                payment_frequency: "",
                amount_requested: ""
            }
        };
    },
    methods: {
        checkAccountNumber(evt){
            //check if account_number is less than 10 and reset account_details
            if(this.loan_data.account_number.length < 10){
                this.account_details = null;
            }
        },
        showCreateLoanModal(item = null) {
            this.createLoanModal = true;
        },
        closeCreateModal(){
            this.createLoanModal = false;
        },
        showCbaCreateLoanModal(item = null) {
            this.createLoanCbaModal = true;
        },
        closeCbaCreateModal(){
            this.createLoanCbaModal = false;
            this.cba_loan_details = null;
            this.cba_reference = null;
        },
        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async allProductLoan(page) {
            this.reportsLoading = true;

            try {
                const response = await ApiService.get(
                    `loan/other/all?page=${page}&reference=${this.reference}&account_number=${this.account_number}&loan_status=${this.status}`
                );
                console.log(response);
                this.loanProducts = response.data.data.data;
                this.current = response.data.data.current_page;
                this.total = response.data.data.last_page;
                this.loanProductsLoading = false;
                this.reportsLoading = false;
            } catch (error) {
                console.log(error.response);
                this.loanProductsLoading = false;
                this.reportsLoading = false;
            } finally {
                this.loanProductsLoading = false;
                this.reportsLoading = false;
            }
        },
        onPageChange(nextp) {
            console.log(nextp + 'main component');
            if (this.current != nextp) {
                this.allProductLoan(nextp);
            }
        },
        async createApplication() {
            //swal confirmation
            if(this.loan_data.account_number.length < 10){
                Swal.fire({
                    title: 'Invalid Account Number',
                    text: 'Please enter a valid account number',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
                return;
            }
            const swalResponse = await Swal.fire({
                title: `<div>
                    <p >Confirm the following Details</p>
                    <p class='m-0 confirm_font'>Account Name: <span>${this.loan_data.account_name}</span></p>
                    <p class='m-0 confirm_font'>Account Number: <span>${this.loan_data.account_number}</span></p>
                    <p class='m-0 confirm_font'>Nature of Business: <span>${this.loan_data.nature_of_business}</span></p>
                    <p class='m-0 confirm_font'>Business Description: <span>${this.loan_data.business_description}</span></p>
                    <p class='m-0 confirm_font'>Duration: <span>${this.loan_data.duration}</span></p>
                    <p class='m-0 confirm_font'>Amount Requested: <span>${this.loan_data.amount_requested}</span></p>
                    </div>`,
                text: "You are about to create a loan application",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, create it!",
            });

            if (!swalResponse.isConfirmed) {
                return;
            }

            try {
                this.create_application_loading = true;
                const response = await ApiService.post("loan/other/create", this.loan_data);
                console.log(response);
                this.create_application_loading = false;
                this.createLoanModal = false;
                this.$router.push({
                    name: "ViewOtherLoanDetail",
                    params: {
                        slug : response.data.data.reference
                    }
                });
            } catch (error) {
                this.create_application_loading = false;
                console.log(error.response);
                ErrorService.displayErrorAlert(error.response.data);
            }
        },
        async getAccountDetails() {
            try {
                this.get_account_detail_loading = true;
                const response = await ApiService.post("account/check_account_details", {
                    account_number: this.loan_data.account_number
                });
                this.account_details = response.data.data;
                this.loan_data.account_name = this.account_details.name;
                this.loan_data.bvn = this.account_details.bvn;
                this.get_account_detail_loading = false;
                this.step = 2;
            } catch (error) {
                this.get_account_detail_loading = false;
                console.log(error.response);
                ErrorService.displayErrorAlert(error.response.data);
            }
        },
        async getCbaAccountDetails() {
            var _action_type = this.cba_loan_details == null ? 'preview' : 'create';

            if(_action_type == 'create'){
                //create swal confirmation
                const swalResponse = await Swal.fire({
                    title: `<div>
                        <p >Confirm the following Details</p>
                        <p class='m-0 confirm_font'>Account Name: <span>${this.cba_loan_details.account_name}</span></p>
                        <p class='m-0 confirm_font'>Account Number: <span>${this.cba_loan_details.account_number}</span></p>
                        <p class='m-0 confirm_font'>Amount Requested: <span>${this.cba_loan_details.amount_requested}</span></p>
                        <p class='m-0 confirm_font'>CBA Account: <span>${this.cba_loan_details.core_banking_loan_reference}</span></p>
                        <p class='m-0 confirm_font'>Interest Amount: <span>${this.cba_loan_details.interest_amount}</span></p>
                        <p class='m-0 confirm_font'>Interest Rate: <span>${this.cba_loan_details.interest_rate}</span></p>
                        <p class='m-0 confirm_font'>Loan Balance: <span>${this.cba_loan_details.loan_balance}</span></p>
                        <p class='m-0 confirm_font'>Loan Status: <span>${this.cba_loan_details.loan_status}</span></p>
                        </div>`,
                    text: "You are about to create a loan application",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, create it!",
                });

                if (!swalResponse.isConfirmed) {
                    return;
                }
            }

            try {
                this.get_cba_account_detail_loading = true;
                const response = await ApiService.post("loan/other/create_loan_application_from_cba", {
                    loan_cba_reference: this.cba_reference,
                    action_type: this.cba_loan_details == null ? 'preview' : 'create'
                });
                this.get_cba_account_detail_loading = false;
                this.cba_loan_details = response.data.data;
                console.log(this.cba_loan_details);
                
            } catch (error) {
                this.get_cba_account_detail_loading = false;
                console.log(error.response);
                ErrorService.displayErrorAlert(error.response.data);
            }
        }, 
        async getStates() {
            try {
                const response = await ApiService.get("utility/state-list");
                this.states = response.data.data;
            } catch (error) {
                console.log(error);
            }
        },       
    },
    mounted() {
        this.allProductLoan(1);
        this.getStates();
    }
};
</script>

<style>
/* Hide all steps by default: */
.step-panel {
    display: none;
}
.confirm_font{
    font-size: 11px;
    font-weight: 600;
}

</style>